var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment, } from 'react';
import { Edge, Align } from '../util/getRelativePosition';
import { useOverlay } from '../hooks/useOverlay';
import { useAppendedElement } from '../hooks/useAppendElement';
import { createPortal } from 'react-dom';
export var Popover = function (_a) {
    var _b = _a.edge, edge = _b === void 0 ? Edge.Bottom : _b, _c = _a.align, align = _c === void 0 ? Align.Start : _c, renderTrigger = _a.renderTrigger, renderPopover = _a.renderPopover, children = _a.children;
    var _d = useOverlay(edge, align), open = _d.open, setOpen = _d.setOpen, triggerRef = _d.triggerRef, containerRef = _d.containerRef, overlayStyle = _d.overlayStyle;
    var portal = useAppendedElement();
    return (jsx(Fragment, null,
        renderTrigger(setOpen, triggerRef, open),
        open && (jsx(Container, { renderPopover: renderPopover, containerRef: containerRef, overlayStyle: overlayStyle, setOpen: setOpen, portal: portal }, children))));
};
var Container = function (_a) {
    var renderPopover = _a.renderPopover, children = _a.children, containerRef = _a.containerRef, overlayStyle = _a.overlayStyle, setOpen = _a.setOpen, portal = _a.portal;
    return createPortal(jsx("div", { ref: containerRef, sx: __assign({ position: 'absolute', zIndex: 'popover', marginRight: 'calc(100% - 100vw)', mt: 1 }, overlayStyle), onClick: function (e) {
            e.stopPropagation();
            setOpen(false);
        } },
        renderPopover && renderPopover(setOpen),
        children), portal);
};
//# sourceMappingURL=Popover.js.map